var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16666 3.02075H6.66666C6.49583 3.02075 6.35416 2.87909 6.35416 2.70825C6.35416 2.53742 6.49583 2.39575 6.66666 2.39575H9.16666C9.3375 2.39575 9.47916 2.53742 9.47916 2.70825C9.47916 2.87909 9.3375 3.02075 9.16666 3.02075Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.02075H0.833336C0.662503 3.02075 0.520836 2.87909 0.520836 2.70825C0.520836 2.53742 0.662503 2.39575 0.833336 2.39575H2.5C2.67084 2.39575 2.8125 2.53742 2.8125 2.70825C2.8125 2.87909 2.67084 3.02075 2.5 3.02075Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 4.47917C3.19167 4.47917 2.39584 3.68333 2.39584 2.70833C2.39584 1.73333 3.19167 0.9375 4.16667 0.9375C5.14167 0.9375 5.9375 1.73333 5.9375 2.70833C5.9375 3.68333 5.14167 4.47917 4.16667 4.47917ZM4.16667 1.5625C3.53334 1.5625 3.02084 2.075 3.02084 2.70833C3.02084 3.34167 3.53334 3.85417 4.16667 3.85417C4.8 3.85417 5.3125 3.34167 5.3125 2.70833C5.3125 2.075 4.8 1.5625 4.16667 1.5625Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 7.60425H7.5C7.32917 7.60425 7.1875 7.46258 7.1875 7.29175C7.1875 7.12091 7.32917 6.97925 7.5 6.97925H9.16667C9.3375 6.97925 9.47917 7.12091 9.47917 7.29175C9.47917 7.46258 9.3375 7.60425 9.16667 7.60425Z",
    fill: "#909090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 7.60425H0.833336C0.662503 7.60425 0.520836 7.46258 0.520836 7.29175C0.520836 7.12091 0.662503 6.97925 0.833336 6.97925H3.33334C3.50417 6.97925 3.64584 7.12091 3.64584 7.29175C3.64584 7.46258 3.50417 7.60425 3.33334 7.60425Z",
    fill: "#909090"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 9.06242C4.85833 9.06242 4.0625 8.26659 4.0625 7.29159C4.0625 6.31659 4.85833 5.52075 5.83333 5.52075C6.80833 5.52075 7.60417 6.31659 7.60417 7.29159C7.60417 8.26659 6.80833 9.06242 5.83333 9.06242ZM5.83333 6.14575C5.2 6.14575 4.6875 6.65825 4.6875 7.29159C4.6875 7.92492 5.2 8.43742 5.83333 8.43742C6.46667 8.43742 6.97917 7.92492 6.97917 7.29159C6.97917 6.65825 6.46667 6.14575 5.83333 6.14575Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconLight);
export default __webpack_public_path__ + "static/media/filter-icon-light.0e2a76b2b1d721e86565ccd285149fc3.svg";
export { ForwardRef as ReactComponent };